import { WetoTrackingEvent } from '@app-types/eligibility';
import { TrackingType } from '@app-types/tracking';

import { getQueryParam } from '@helpers/query-params';
import { sendTracking } from '@helpers/tracking';

import { ERROR_CONTEXT } from '@constants/provider';

import { JourneyConfigType } from './journey-config';

export function sendEligibilityTracking(config: JourneyConfigType, { data, pageTag }: WetoTrackingEvent['event']) {
    if (config.tracking.universe === 'Boutique_mixte' && !getQueryParam('plan_id')) {
        config.tracking.universe = 'Boutique_fai';
    }
    const trackingData: TrackingType = pageTag
        ? {
              ...config.tracking,
              ...(data ?? {}),
              variables: {
                  ...data?.variablesSpecifiques,
                  ...(config.tracking.variables as Record<string, string>),
                  ...{ version: 'stable' },
              },
              variant: {
                  ...data?.pageVariante,
                  ...(config.tracking.variant as Record<string, string>),
              },
          }
        : {
              action: data.actionClic,
              category: data.categorieClic,
              name: data.nomClic,
              universe: config.tracking.universe,
              marketLine: config.tracking.marketLine,
          };

    trackingData.journey = data?.parcours;
    trackingData.url = data?.url ?? undefined;
    trackingData.site = config.tracking.site;
    sendTracking(false, trackingData);
}

export function sendUpsellModalOpen(config: { universe?: string; marketLine?: string }) {
    sendTracking(false, {
        action: 'Impression',
        category: 'Modale_upsell',
        name: `Affichage_modale_upsell`,
        universe: config.universe,
        marketLine: config.marketLine,
    });
}

export function sendUpsellModalClose(config: { universe?: string; marketLine?: string }) {
    sendTracking(false, {
        action: 'Clic_selection',
        category: 'Modale_upsell',
        name: 'Fermer_modale',
        universe: config.universe,
        marketLine: config.marketLine,
    });
}

export function sendUpsellModalClick(
    config: { universe?: string; marketLine?: string },
    rangeNgCommercialSeries: string,
) {
    sendTracking(false, {
        action: 'Clic_selection',
        category: 'Modale_upsell',
        name: rangeNgCommercialSeries,
        universe: config.universe,
        marketLine: config.marketLine,
    });
}

export function sendTrackingFromEligibilityMismatchError(config: JourneyConfigType, nameToTrack: string) {
    sendTracking(false, {
        action: 'Clic_redirection',
        category: 'Offre_non_eligible_fibre',
        name: nameToTrack,
        universe: config.tracking.universe,
        marketLine: config.tracking.marketLine,
        site: config.tracking.site,
    });
}

export function sendTrackingAddFaiToCart(config: JourneyConfigType, nameToTrack: string, isEligibleFiber: boolean) {
    sendTracking(false, {
        action: 'Clic_redirection',
        category: `Offre_${isEligibleFiber ? '' : 'non_'}eligible_fibre`,
        name: nameToTrack,
        universe: config.tracking.universe,
        marketLine: config.tracking.marketLine,
        site: config.tracking.site,
    });
}

export function sendTlvLinkClick(config: JourneyConfigType) {
    sendTracking(false, {
        action: 'Clic_redirection',
        category: 'Test_eligibilite_recherche_adresse',
        name: 'Faire_rappeler_par_un_conseiller',
        universe: config.tracking.universe,
        marketLine: config.tracking.marketLine,
    });
}

const ERROR_TRACKING_NAME: Record<ERROR_CONTEXT, string> = {
    [ERROR_CONTEXT.ERROR]: 'Erreur_une_erreur_est_survenue_de_notre_cote',
    [ERROR_CONTEXT.NO_OFFER]: 'Erreur_aucune_offre_eligible',
    [ERROR_CONTEXT.MISMATCH_CONFIG]: 'Erreur_offre_non_eligible',
};

export function sendErrorImpressionTracking(config: JourneyConfigType, error: ERROR_CONTEXT) {
    sendTracking(false, {
        action: 'Impression',
        category: 'Erreur',
        name: ERROR_TRACKING_NAME[error],
        universe: config.tracking.universe,
        marketLine: config.tracking.marketLine,
        site: config.tracking.site,
    });
}

export function sendForecastTracking(config: { universe?: string; marketLine?: string }) {
    sendTracking(false, {
        action: 'Clic_validation',
        category: 'Pop_in::Prise_interet_FTTH',
        name: 'Être contacté',
        universe: config.universe,
        marketLine: config.marketLine,
    });
}
